export default __webpack_public_path__ + "static/media/petal_s4.df10534b.svg";